jQuery(document).ready(function ($) {
  document.addEventListener('click', function (e) {
    if (
      e &&
      e.target &&
      e.target.href &&
      e.target.href.endsWith('#show-form')
    ) {
      var formContainer = document.getElementById('form-container');
      formContainer.classList.add('pop-form-container');
      var innerContainer = formContainer.querySelector('.contact-bg');

      var closeBtn = document.createElement('button');
      closeBtn.classList.add('pop-form-close');

      innerContainer.prepend(closeBtn);

      closeBtn.addEventListener('click', function () {
        formContainer.classList.remove('pop-form-container');
        closeBtn.remove();
      });
    }
  });

  document.addEventListener('wpcf7mailsent', function (event) {
    $('#' + event.detail.unitTag + ' .contact-fields').slideUp();
  });
});
